import { de } from "./de";

export const fr: typeof de = {
  title: "Calculer la portée et la hauteur du jet ",
  text: "Veuillez sélectionner un type de canon et de buse illustré dans l’animation suivante. Après avoir réglé vos conditions de fonctionnement, la portée et la hauteur du jet ainsi que la force de réaction émergente sont calculées. Le résultat peut être exporté au format PDF.",
  components: {
    addButton: {
      defaultAriaLabel: "Ajouter",
    },
    languageSwitcher: {
      english: "Anglais",
      german: "Allemand",
      french: "Français",
      imp: "Impérial",
      met: "Métrique",
    },
    obstacleFormInput: {
      depth: "Profondeur",
      distance: "Distance",
      height: "Hauteur",
    },
    resultsTextualSummary: {
      range: "Portée",
      throwingHeight: "Hauteur du jet",
      distanceOfHeighestPoint: "Distance du point le plus haut",
      recoil: "Force de réaction",
      footprintDiameter: "Diamètre de l’empreinte",
    },
    settings: {
      title: "Paramètres",
      headlineAngle: "Angle",
      headlineExtinguishingAgentFlow: "Débit d’agent extincteur",
      headlineGroundObstacle: "Obstacle au sol",
      headlineMedium: "Agent extincteur",
      headlineMonitorHeight: "Hauteur du canon",
      headlinePressure: "Pression (à la bride d'entrée)",
      headlineRoofObstacle: "Obstacle au plafond",
      obstacleLabel: "Obstacle",
      obstacleLabelWithNumber: "Obstacle {{obstacleNumber}}",
      nozzleOption: "Buse: {{nozzleName}}",
      mediumFoam: "Mousse",
      mediumWater: "Eau",
      monitorOption: "Canon: {{monitorName}}",
    },
    removeButton: {
      defaultAriaLabel: "Supprimer",
    },
    results: {
      title: "Résultat",
      footerText:
        "La portée est mesurée à partir du point de décharge au niveau du canon jusqu’au centre de la zone d’impact en l’absence de vent.",
      buttonInfo: "Explication",
      buttonPdf: "Exporter en PDF ",
    },
    chart: {
      rangeInMeters: "Portée en mètre",
      heightInMeters: "Hauteur en mètre",
      rangeInFoot: "Portée en pied",
      heightInFoot: "Hauteur en pied",
    },
    pdfExport: {
      createdAt: "Créé le {{dd}}.{{mm}}.{{yyyy}}",
      footerLinkLabel: "www.firedos.com",
    },
  },
  formatting: {
    numberWithoutDecimalPoints: "{{number, number(maximumFractionDigits: 0)}}",
    numberMaxOneDecimalPoint: "{{number, number(maximumFractionDigits: 1)}}",
    numberMaxTwoDecimalPoints: "{{number, number(maximumFractionDigits: 2)}}",
    numberMaxFourDecimalPoints: "{{number, number(maximumFractionDigits: 4)}}",
  },
  units: {
    bar: "bar",
    kiloNewton: "kN",
    literPerMinute: "l/min",
    meter: "m",
    foot: "ft",
    gallonPerMinute: "gal/min",
    psi: "psi",
  },
};
